const movieFilters = new Map()
movieFilters.set('popular', 'Popular')
movieFilters.set('now_playing', 'Now playing')
movieFilters.set('top_rated', 'Top rated')
movieFilters.set('upcoming', 'Upcoming')

export default Object.freeze(movieFilters)
